import React from "react";
import { appMode as appModeOptions } from "./Variables";

/**
 * Multi-select for App Mode. The selected modes decide which navigation tabs the
 * user gets (see MenuItem.js / Header.js) — DI Mode shows "Add Invoices",
 * FBR/PRA POS Mode shows "Add POS Invoice".
 */
export const AppModeSelect = ({ value, error, onChange }) => {
  const selected = Array.isArray(value) ? value : [];

  const toggleMode = (mode) => {
    onChange(
      selected.includes(mode)
        ? selected.filter((item) => item !== mode)
        : [...selected, mode],
    );
  };

  return (
    <div className="md:col-span-2">
      <label className="block mb-1 font-medium">
        App Mode <span className="text-red-500">*</span>
      </label>
      <div
        className={`w-full px-4 py-3 border rounded-md grid grid-cols-1 sm:grid-cols-3 gap-2 ${
          error ? "border-red-500" : "border-gray-300"
        }`}
      >
        {appModeOptions?.map((item) => (
          <label
            key={item?.value}
            className="flex items-center gap-2 cursor-pointer select-none"
          >
            <input
              type="checkbox"
              name="appMode"
              value={item?.value}
              checked={selected.includes(item?.value)}
              onChange={() => toggleMode(item?.value)}
              className="h-4 w-4 accent-blue-600 cursor-pointer"
            />
            <span>{item?.label}</span>
          </label>
        ))}
      </div>
      <p className="text-gray-500 text-xs mt-1">
        Select one or more modes. Navigation tabs are shown according to this
        selection.
      </p>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default AppModeSelect;
